import {OpzioniItem} from "../gestversore/types";


export const DittaList: OpzioniItem[] = [
  { id: "1",  label: "IN4IT" },
  { id: "2",  label: "BS" },
];

export type ProcedureResponse = {
  status: string;
  message: string;
};

export type MonitorProgettiRiepilogo = {
  CODDITTA: number;
  DESDITTA?: string;
  DESPROG?: string;
  DATAINIZIO?: Date | null;
  STATOPROG?: string;
  CODPROG: string;
  OREORD?: number;
  OREORDCONT?: number;
  OREORDPREV?: number;
  ORECONT?: number;
  OREPREV?: number;
  OREORDASSTELNOCONTPREV?: number;
  OREDIFFSTIMA: number;
  OREDIFFPREP: number;
  COSTI: number;
  RICAVI: number;
  MARGINE: number;
  DATAAGG?: Date | null;
  DATAGOLIVEPIAN?: Date | null;
  PERCOMP?: number;
  DATACOLL?: Date | null;
  GRUSTAT4?: string;
  REF?: string;
  INDCLIBLOC?: string;
};

export type MonitorProgettiRiepilogoApiResponse = {
  results: Array<MonitorProgettiRiepilogo>;
  count: number;
};



export type MonitorProgettiNodi = {
  CODDITTA: number;
  DESDITTA?: string;
  DESPROG?: string;
  DATAINIZIO?: Date | null;
  STATOPROG?: string;
  CODPROG: string;
  CODNODO: string;
  DESNODO?: string;
  TIPONODO?: string;
  OREORDNODO?: number;
  OREORDCONT?: number;
  OREORDPREV?: number;
  ORECONT?: number;
  OREPREV?: number;
  OREORDASSTELNOCONTPREV?: number;
  OREDIFFPREP: number;
  OREDIFFSTIMA: number;
  RICAVI: number;
  DATAAGG?: Date | null;
  DATAGOLIVEPIAN?: Date | null;
  PERCOMP?: number;
  DATACOLL?: Date | null;
  GRUSTAT4?: string;
  OREDIFF?: number;
  INDCLIBLOC?: string;

};

export type MonitorProgettiNodiApiResponse = {
  results: Array<MonitorProgettiNodi>;
  count: number;
};

export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };


export type UserProg = {
  id: number;
  username: string;
  codprog: string;

};


export function mapJsonToUserProg(jsonData: any): UserProg {
  return {
    id: jsonData.BT26_ID || 0,
    username: jsonData.BT26_USERNAME || '',
    codprog: jsonData.BT26_CODPROG || '',
  };
}

export function mapUserProgToJson(userProg: UserProg) {
  return {
    BT26_ID: userProg.id,
    BT26_USERNAME: userProg.username,
    BT26_CODPROG: userProg.codprog,
  };
}


export type RicProg = {
  codprog?: string;
  ditta?: number;
  ricavi: number;
 };

export type RicProgApiResponse = {
  results: Array<RicProg>;
  count: number;
};


export function mapJsonToRicProgApiResponse(jsonData: any): RicProgApiResponse {
 const mappedData: RicProgApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      id: item.BT24_ID,
      codprog: item.BT24_CODPROG,
      ricavi: item.BT24_RICAVI,
      ditta: item.BT24_DITTA,
    }))
  };
  return mappedData;
};

export function mapRicProgToJson(ricProg: RicProg) {
  return {
    BT24_CODPROG: ricProg.codprog,
    BT24_RICAVI: ricProg.ricavi,
    BT24_DITTA: ricProg.ditta,
  };
};

export function mapJsonToRicProg(jsonData: any): RicProg {
  return {
    codprog: jsonData.BT24_CODPROG,
    ricavi: jsonData.BT24_RICAVI,
    ditta: jsonData.BT24_DITTA,
  };
};


